<template>
  <div>
    <v-btn icon  color="none" :to="{ name : 'calendar' }">
      <v-icon>arrow_left</v-icon>
    </v-btn>
    <div v-if="loading">
      <v-progress-linear color="primary" indeterminate></v-progress-linear>
    </div>
    <div v-else>
    <v-layout wrap>
      <v-flex  xs12 sm12 md8 lg8>
        <v-checkbox v-model="showDeleted" @change="filter" label="Pokaż tylko usunięte wydarzenia"/>
      </v-flex>
      <v-flex xs12 sm12 md4 lg4>
        <v-text-field v-model="searchText" @change="filter" label="Szukaj"></v-text-field>
      </v-flex>
    </v-layout>

    <v-data-table :pagination.sync="pagination" :headers=" headers" :items="calednarHistory" class="elevation-10">
      <template v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.title }}</td>
        <td>{{ props.item.description }}</td>
        <td>{{ props.item.scheduledAt }}</td>
        <td>{{ props.item.created_by_full_name }}</td>
        <td>{{ props.item.updated_by_full_name }}</td>
        <td>{{ props.item.updated_at }}</td>
        <td>{{ props.item.deleted == 0 ? "NIE" : "TAK" }}</td>
      </template>
    </v-data-table>
  </div>
  </div>
</template>

<script>
import ItemForm from "@/components/storage/ItemForm";
import New from "@/components/storage/New";
import Messenger from "@/plugins/Messenger";
export default {
  name: "HistoryAll",
  data(){
    return{
      calednarHistory : [],
      allCalednarHistory : [],
      loading:true,
      searchText:'',
      showDeleted: false,
      products : [],
      users:[],
      headers:[
        {
          text: 'ID',
          value: "id",
        },
        {
          text: this.$t('archive.name'),
          value: 'title'
        },
        {
          text: this.$t('department.description'),
          value: 'description'
        },
        {
          text: 'Zaplanowano na',
          value: 'scheduledAt'
        },
        {
          text: 'Utworzone przez',
          value: 'created_by'
        },
        {
          text: 'Modyfikowane przez',
          value: 'modified_by'
        },
        {
          text: 'Data modyfikacji',
          value: 'updated_at'
        },
        {
          text: 'Usunieto',
          value: 'active'
        },
      ],
      pagination:{
        descending: true,
        page: 1,
        rowsPerPage: 25 // -1 for All",
      }
    }
  },
  methods:{
    getUser(id){
      let user =  this.users ? this.users.find(el => el.id == id) : false
      if(user){
        return user.name +" " + user.surname
      }
      return ""
    },
    filter() {
      let text = this.searchText
      if (text == "") {
        this.calednarHistory = this.allCalednarHistory.filter(history => this.showDeleted ? history.deleted == 1 : true)
      }

      text = text.toLowerCase()
      this.calednarHistory = this.allCalednarHistory.filter(history =>
          history.created_by_full_name.toLowerCase().includes(text) || history.updated_by_full_name.toLowerCase().includes(text)
          || history.title.toLowerCase().includes(text) || history.description.toLowerCase().includes(text)
          || history.scheduledAt.includes(text) || history.updated_at.includes(text)
      ).filter(history => this.showDeleted ? history.deleted == 1 : true)
    },
    expandCalendarHistory(ch){
      ch.created_by_full_name = this.getUser(ch.created_by)
      ch.updated_by_full_name = this.getUser(ch.updated_by)
      return ch
    }
  },
  created() {
    this.loading = true
    let users = this.$http.get('users')
    let history = this.$http.get(`calendar/history`)

    Promise.all([history, users]).then(data=>{
      this.users = data[1].data
      this.calednarHistory = data[0].data.map(this.expandCalendarHistory)
      this.allCalednarHistory = this.calednarHistory.map(el=>el)
      this.loading = false
    }).catch(()=>{
      Messenger.emitError("Cannot download event history")
    })
  }
}
</script>

<style scoped>

</style>